import getCookie from "helpers/getCookie";

export const parseUTMCookie = (cookieStr: string) => {
  const params: any = {};
  cookieStr.split("|").forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key) params[key] = value || "";
  });
  return params;
};

export const getUtmParams = (urlParams: URLSearchParams, initialUtmParamsFromCookie = "") => {
  const utmParamsCookies = initialUtmParamsFromCookie || getCookie("initial_utm_params") || "";
  const parsedUtmParams = parseUTMCookie(utmParamsCookies);

  const utmSource = urlParams?.get("utm_source") || parsedUtmParams?.utm_source || "";
  const utmMedium = urlParams?.get("utm_medium") || parsedUtmParams?.utm_medium || "";
  const campaign = urlParams?.get("utm_campaign") || parsedUtmParams?.utm_campaign || "";

  return { utmSource, utmMedium, campaign };
};
